import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useHeaderHeight from '@/hooks/useHeaderHeight';
import { PAGE_TITLES, SUPPORT_CONTACT_URL } from '@/constants/appConfig';
import {
  ErrorPageContainer,
  MessageBox,
  IconWrapper,
  Title,
  Description,
  ActionLink,
} from './styles/ErrorPage.styles';

/**
 * AccessDenied Component
 * Displays when a user attempts to access a resource without proper permissions
 *
 * @component
 * @return {JSX.Element} Access denied error page
 */
const AccessDenied = () => {
  document.title = PAGE_TITLES.ACCESS_DENIED;

  const headerHeight = useHeaderHeight();

  if (headerHeight === null) return null;

  return (
    <ErrorPageContainer headerHeight={headerHeight}>
      <MessageBox>
        <IconWrapper color="#faad14">
          <ExclamationCircleOutlined />
        </IconWrapper>
        <Title>Access Denied</Title>
        <Description hasAction>
          You do not have permission to view this page. If you believe this is a
          mistake, please contact your system administrator.
        </Description>
        <ActionLink href={SUPPORT_CONTACT_URL}>
          Contact Administrator
        </ActionLink>
      </MessageBox>
    </ErrorPageContainer>
  );
};

export default AccessDenied;
